import { PlayList } from "../pages/content/Playlist";
import { Video } from "../pages/content/types";
import http from "../utils/http";

export interface AppBanner {
  id: string;
  photoUrl: string;
  bannerType: "VIDEO" | "PLAYLIST" | "SUBSCRIPTION";
  position: 0 | 1 | 2;
  destination: string;
}

const GetBannerList = async (): Promise<AppBanner[]> => {
  const urlPath = `/admin/app-config/banners`;

  const result = await http.get({ path: urlPath });

  if (result.status == 200 && (result.data as AppBanner[])) {
    return result.data as AppBanner[];
  } else {
    throw new Error(`Failed to fetch banners. Status code: ${result.status}`);
  }
};

export interface ICreateBanner {
  photoUrl?: string;
  bannerType?: "VIDEO" | "PLAYLIST" | "SUBSCRIPTION";
  position: 0 | 1 | 2;
  destination?: string;
}
const createBanner = async ({
  photoUrl,
  bannerType,
  position,
  destination,
}: ICreateBanner): Promise<number> => {
  const urlPath = `/admin/app-config/banner`;

  const result = await http.post({
    path: urlPath,
    body: { photoUrl, bannerType, position, destination },
  });

  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};

export interface TrendingVideos {
  id: string;
  video: Video;
  position: 0 | 1 | 2 | 3;
}
export interface FreeBiesHome {
  id: string;
  playList: PlayList;
  position: 0 | 1 | 2 | 3;
}

const GetTrendingVideos = async (): Promise<TrendingVideos[]> => {
  const urlPath = `/admin/app-config/trending-videos`;

  const result = await http.get({ path: urlPath });

  if (result.status == 200 && (result.data as TrendingVideos[])) {
    return result.data as TrendingVideos[];
  } else {
    throw new Error(`Failed to fetch banners. Status code: ${result.status}`);
  }
};
const GetFreeBiesHome = async (): Promise<FreeBiesHome[]> => {
  const urlPath = `/admin/app-config/home-playlists`;

  const result = await http.get({ path: urlPath });

  if (result.status == 200 && (result.data as FreeBiesHome[])) {
    return result.data as FreeBiesHome[];
  } else {
    throw new Error(`Failed to fetch banners. Status code: ${result.status}`);
  }
};

const AddFreeBriesHome = async ({
  playlistId,
  position,
}: {
  playlistId: string;
  position: 0 | 1 | 2 | 3;
}): Promise<number> => {
  const urlPath = `/admin/app-config/home-playlist`;

  const result = await http.post({
    path: urlPath,
    body: { playlistId, position },
  });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
  // return 0;
};
const AddTrendingVideo = async ({
  videoId,
  position,
}: {
  videoId: string;
  position: 0 | 1 | 2 | 3;
}): Promise<number> => {
  const urlPath = `/admin/app-config/trending-video`;

  const result = await http.post({
    path: urlPath,
    body: { videoId, position },
  });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};

const RemoveBanner = async (id: string): Promise<number> => {
  const urlPath = `/admin/app-config/banners/${id}`;
  const result = await http.deleteHttp({ path: urlPath, body: {} });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};
const RemoveTrendingVideo = async (id: string): Promise<number> => {
  const urlPath = `/admin/app-config/trending-videos/${id}`;
  const result = await http.deleteHttp({ path: urlPath, body: {} });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};
const RemoveFreebie = async (id: string): Promise<number> => {
  const urlPath = `/admin/app-config/home-playlist/${id}`;
  const result = await http.deleteHttp({ path: urlPath, body: {} });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};

export {
  GetBannerList,
  createBanner,
  GetTrendingVideos,
  GetFreeBiesHome,
  AddFreeBriesHome,
  AddTrendingVideo,
  RemoveBanner,
  RemoveTrendingVideo,
  RemoveFreebie,
};
